import { ErrorInRoute } from "@core/presentation/components/routing/error-in-route/error-in-route.component.tsx";
import { Route } from "react-router";

export const CustomGraphRoutes = {
    CustomGraph: "/custom-graph",
} as const;

export const customGraphRoutes = (
    <Route
        path={CustomGraphRoutes.CustomGraph}
        errorElement={<ErrorInRoute />}
        lazy={async () => {
            const { CustomGraphModuleLayout } =
                await import("@custom-graph/presentation/layout/custom-graph-module.layout.tsx");
            return { Component: CustomGraphModuleLayout };
        }}
    >
        <Route
            index
            lazy={async () => {
                const { CustomGraphWebPage } =
                    await import("@custom-graph/presentation/pages/custom-graph/custom-graph-web.page.tsx");
                return { Component: CustomGraphWebPage };
            }}
        />
    </Route>
);
